import 'css-chunksrc/client/scenes/projectDuplication/projectEdition/styles.scss';export default {
  "form": "_form_1jvwp_1",
  "main": "_main_1jvwp_10",
  "buttons": "_buttons_1jvwp_15"
};